
import React from 'react';
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { FormHeading } from "./FormHeading";

interface ProductNameFieldProps {
  form: UseFormReturn<any>;
}

export const ProductNameField: React.FC<ProductNameFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormItem>
          <FormHeading label="Product Name" />
          <FormControl>
            <Input {...field} placeholder="Enter product name" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
